import React from "react";
import DefaultLoading from "theme/components/helpers/Loadable/DefaultLoading";

const LoadingRoute = () => (
  <div className="loading-route">
    <DefaultLoading />
  </div>
);

export default LoadingRoute;
